export const isObjectOrStringifiedObject = (value: Record<string, unknown> | string) => {
    if (typeof value === 'object') return true;

    if (typeof value === 'string') {
        try {
            const parsedValue = JSON.parse(value);
            return typeof parsedValue === 'object' && parsedValue !== null;
        } catch (e) {
            return false;
        }
    }

    return false;
};

export const tryParseJson = (value: string | unknown) => {
    try {
        return JSON.parse(value as string);
    } catch {
        return value;
    }
};
